
import { Link } from "react-router-dom";
import { Product } from "@/lib/types";
import { getCategory } from "@/lib/data/categories";
import { conditionLabels, formatPrice } from "@/lib/utils";
import RevealOnScroll from "@/components/ui/RevealOnScroll";
import ProductCard from "@/components/product/ProductCard";

export default function RareFinds({ products }: { products: Product[] }) {
  if (products.length === 0) return null;
  const [featured, ...rest] = products;
  const featuredCategory = getCategory(featured.category);

  return (
    <section className="py-16 md:py-20 bg-[var(--nm-bg-elevated)]">
      <div className="nm-container">
        <RevealOnScroll>
          <span className="text-xs tracking-[0.3em] uppercase text-[var(--nm-pink)]">
            Curated
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-semibold text-white">
            Rare Finds
          </h2>
          <p className="mt-3 text-[var(--nm-ink-muted)] max-w-md">
            The stuff you didn&apos;t know you were looking for.
          </p>
        </RevealOnScroll>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-5 gap-5">
          <RevealOnScroll className="lg:col-span-3">
            <Link
              to={`/product/${featured.id}`}
              className="nm-grain group relative block h-full min-h-[420px] rounded-2xl overflow-hidden bg-center bg-cover"
              style={
                featured.images[0]
                  ? { backgroundImage: `url(${featured.images[0]})` }
                  : { background: featuredCategory?.gradient }
              }
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8">
                <span className="text-[10px] tracking-[0.2em] uppercase text-white/80 mb-3">
                  {featuredCategory?.name}
                </span>
                <h3 className="font-display text-2xl md:text-4xl font-semibold text-white max-w-md">
                  {featured.title}
                </h3>
                <div className="mt-4 flex items-center gap-4 text-white/80 text-sm">
                  <span className="font-display text-xl text-white font-semibold">
                    {formatPrice(featured.price)}
                  </span>
                  <span>{conditionLabels[featured.condition]}</span>
                  <span>{featured.sellerName}</span>
                </div>
              </div>
            </Link>
          </RevealOnScroll>

          <div className="lg:col-span-2 grid grid-cols-2 gap-5">
            {rest.slice(0, 4).map((p, i) => (
              <RevealOnScroll key={p.id} delay={i * 0.08}>
                <ProductCard product={p} />
              </RevealOnScroll>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
